'use client';

import { usePathname } from 'next/navigation';
import { ComponentProps, useMemo } from 'react';

import { FancyLink } from '../FancyLink';

export function NavLink(props: ComponentProps<typeof FancyLink>) {
    const { href } = props;

    const pathname = usePathname()!;

    const isActive = useMemo(
        () => !!href && pathname.startsWith(new URL(href, 'http://.').pathname),
        [href, pathname]
    );

    return <FancyLink {...props} isActive={isActive} />;
}
